// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/TwemojiMozilla.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Twemoji Mozilla";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.stdropdown-container {
  text-align: left;
  border: 1px solid #ccc;
  position: relative;
  border-radius: 5px;
  font-family: Arial, Helvetica, sans-serif;
}

.stdropdown-flag {
  font-family: "Twemoji Mozilla" !important;
}

.stdropdown-menu::-webkit-scrollbar {
  width: 2px;
}

.stdropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.stdropdown-menu::-webkit-scrollbar-thumb {
  background: #888;
}

.stdropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.stdropdown-input {
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
}

.stdropdown-menu {
  position: absolute;
  transform: translateY(4px);
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: auto;
  max-height: 150px;
  background-color: #fff;
  z-index: 99;
}

.stdropdown-item {
  padding: 5px;
  cursor: pointer;
}

.stdropdown-item:hover {
  background-color: rgba(159, 195, 248, 0.4392156863);
}

.stdropdown-item.selected {
  background-color: #0d6efd;
  color: #fff;
}

.stdropdown-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.stdropdown-tag-item {
  background-color: #ddd;
  padding: 2px 4px;
  border-radius: 2px;
  display: flex;
  align-items: center;
}

.stdropdown-tag-close {
  display: flex;
  align-items: center;
}

.stsearch-box {
  padding: 5px;
  background-color: transparent;
}

.stsearch-box input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./../node_modules/react-country-state-city/dist/react-country-state-city.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,+DAAuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"Twemoji Mozilla\";\n  src: url(./fonts/TwemojiMozilla.ttf) format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.stdropdown-container {\n  text-align: left;\n  border: 1px solid #ccc;\n  position: relative;\n  border-radius: 5px;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.stdropdown-flag {\n  font-family: \"Twemoji Mozilla\" !important;\n}\n\n.stdropdown-menu::-webkit-scrollbar {\n  width: 2px;\n}\n\n.stdropdown-menu::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.stdropdown-menu::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n.stdropdown-menu::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.stdropdown-input {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  user-select: none;\n}\n\n.stdropdown-menu {\n  position: absolute;\n  transform: translateY(4px);\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  overflow: auto;\n  max-height: 150px;\n  background-color: #fff;\n  z-index: 99;\n}\n\n.stdropdown-item {\n  padding: 5px;\n  cursor: pointer;\n}\n\n.stdropdown-item:hover {\n  background-color: rgba(159, 195, 248, 0.4392156863);\n}\n\n.stdropdown-item.selected {\n  background-color: #0d6efd;\n  color: #fff;\n}\n\n.stdropdown-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.stdropdown-tag-item {\n  background-color: #ddd;\n  padding: 2px 4px;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n}\n\n.stdropdown-tag-close {\n  display: flex;\n  align-items: center;\n}\n\n.stsearch-box {\n  padding: 5px;\n  background-color: transparent;\n}\n\n.stsearch-box input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
